import React from 'react';
import { useTheme } from '../themes/ThemeProvider';

const ContactPage: React.FC = () => {
  const { branding } = useTheme();
  const contact = branding?.contact;
  const storeName = branding?.store?.name || branding?.name || 'Our Store';

  const address = typeof contact?.address === 'object' ? contact.address : null;
  const addressStr = typeof contact?.address === 'string' ? contact.address : null;

  return (
    <div
      className="container mx-auto px-lg py-3xl"
      style={{ maxWidth: 'var(--container-max-width)' }}
      data-testid="contact-page"
    >
      <div className="mb-3xl text-center">
        <h1 className="font-serif text-4xl md:text-5xl font-semibold text-primary mb-md">
          Contact {storeName}
        </h1>
        <p className="text-text-secondary text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
          Get in touch — we'd love to hear from you.
        </p>
      </div>

      <div className="max-w-xl mx-auto bg-[var(--color-bg)] border border-border rounded-sm p-xl">
        <dl className="flex flex-col gap-lg">
          {contact?.email && (
            <div>
              <dt className="text-xs uppercase tracking-wider text-text-light mb-xs">
                Email
              </dt>
              <dd>
                <a
                  href={`mailto:${contact.email}`}
                  className="text-primary hover:text-primary-hover transition-colors text-base font-medium"
                  data-testid="contact-email"
                >
                  {contact.email}
                </a>
              </dd>
            </div>
          )}

          {contact?.phone && (
            <div>
              <dt className="text-xs uppercase tracking-wider text-text-light mb-xs">
                Phone
              </dt>
              <dd>
                <a
                  href={`tel:${contact.phone.replace(/\s+/g, '')}`}
                  className="text-primary hover:text-primary-hover transition-colors text-base font-medium"
                  data-testid="contact-phone"
                >
                  {contact.phone}
                </a>
              </dd>
            </div>
          )}

          {address && (
            <div>
              <dt className="text-xs uppercase tracking-wider text-text-light mb-xs">
                Address
              </dt>
              <dd className="text-text-secondary text-base" data-testid="contact-address">
                {address.street && <div>{address.street}</div>}
                {(address.postalCode || address.city) && (
                  <div>
                    {address.postalCode}
                    {address.postalCode && address.city ? ' ' : ''}
                    {address.city}
                  </div>
                )}
                {address.region && <div>{address.region}</div>}
                {address.country && <div>{address.country}</div>}
              </dd>
            </div>
          )}

          {addressStr && (
            <div>
              <dt className="text-xs uppercase tracking-wider text-text-light mb-xs">
                Address
              </dt>
              <dd className="text-text-secondary text-base">{addressStr}</dd>
            </div>
          )}

          {!contact && (
            <p className="text-text-secondary text-sm italic">
              Contact information is not currently available.
            </p>
          )}
        </dl>
      </div>
    </div>
  );
};

export default ContactPage;
